import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import {
    SettingType, Setting, BlockType, ValidationMessage, ValidationMessageType,
    CodeBlock,
    SettingOption,
} from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as zephyr from './zephyr';
import * as tios from './tios';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';


export default class I2C extends BasePeripheral {
    constructor() {
        super();
        this.id = 'i2c';
        this.name = 'I2C Bus';
        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];

        const settings: Array<Setting> = [
            {
                id: 'ENABLED',
                name: 'Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '1',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'PORT',
                name: 'Port',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
            },
            {
                id: 'SDA',
                name: 'Serial Data Line',
                settingType: SettingType.PIN,
                required: true,
                meta: 'GPIO',
                default: '',
            },
            {
                id: 'SCL',
                name: 'Serial Clock Line',
                settingType: SettingType.PIN,
                meta: 'GPIO',
                required: true,
                default: '',
            },
            {
                id: 'PULL',
                name: 'Pull',
                settingType: SettingType.OPTION,
                default: '',
                required: true,
                options: [
                    {
                        name: 'None',
                        value: '',
                    },
                    {
                        name: 'Down',
                        value: 'down',
                    },
                    {
                        name: 'Up',
                        value: 'up',
                    },
                ],
            },
            {
                id: 'ITEMS',
                name: 'Items',
                settingType: SettingType.ARRAY,
                default: [],
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getFiles(): Array<string> {
        if (this.project.runtime === 'tios') {
            return this.files;
        }
        return [];
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        if (settingId === 'PORT') {
            const options = [];
            const device = PlatformUtils.getDeviceDefinition(this.project.device.id);
            for (let i = 0; i < device.peripherals.length; i++) {
                if (device.peripherals[i].type === 'i2c') {
                    options.push({
                        name: device.peripherals[i].id,
                        value: device.peripherals[i].settings.PORT.value,
                    });
                }
            }
            return options;
        }
        return super.getSettingOptions(settingId);
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        if (this.getSettingValue('NAME').indexOf(' ') >= 0) {
            errors.push({ message: 'Name cannot contain spaces', messageType: ValidationMessageType.ERROR });
        }
        if (this.getSettingValue('SDA') === undefined) {
            errors.push({ message: `SDA pin not set for ${this.getSettingValue('NAME')}`, messageType: ValidationMessageType.ERROR });
        }
        if (this.getSettingValue('SCL') === undefined) {
            errors.push({ message: `SCL pin not set for ${this.getSettingValue('NAME')}`, messageType: ValidationMessageType.ERROR });
        }
        return errors;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return [];
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/ssi_i2c';
    }
}
